import * as moment from "moment";

export class RemittancePaymentModel {
    constructor(
        public Id: number = 0,
        public RemittanceId: number = 0,
        public Amount: number = 0,
        public Method: string = null,
        public DateCreated: string = moment().format("DD/MM/YYYY"),
        public Refernce: string = null,
        public Paid: boolean = false
    ) { }
}
